import { atelierMuseTemplate } from "./templates/atelierMuse";
import { boutiqueServiceTemplate } from "./templates/boutiqueService";
import { craftsmanModernTemplate } from "./templates/craftsmanModern";
import { dentalStudioTemplate } from "./templates/dentalStudio";
import { groundworkBuildTemplate } from "./templates/groundworkBuild";
import { kineticClubTemplate } from "./templates/kineticClub";
import { launchpadBoldTemplate } from "./templates/launchpadBold";
import { meridianAdvisoryTemplate } from "./templates/meridianAdvisory";
import { nocturneClubTemplate } from "./templates/nocturneClub";
import { northlineStayTemplate } from "./templates/northlineStay";
import { restaurantBrunchTemplate } from "./templates/restaurantBrunch";
import { restaurantCafeBrunchTemplate } from "./templates/restaurantCafeBrunch";
import { restaurantModernTemplate } from "./templates/restaurantModern";
import { restaurantNightBarTemplate } from "./templates/restaurantNightBar";
import { restaurantPizzeriaTemplate } from "./templates/restaurantPizzeria";
import { studioCleanTemplate } from "./templates/studioClean";
import { takeresTemplate } from "./templates/takeres";
import { torqueServiceTemplate } from "./templates/torqueService";
import { voltFlowTemplate } from "./templates/voltFlow";
import type { SiteTemplateDefinition } from "./types";

export const allWebTemplates: SiteTemplateDefinition[] = [
    atelierMuseTemplate,
    studioCleanTemplate,
    boutiqueServiceTemplate,
    craftsmanModernTemplate,
    dentalStudioTemplate,
    groundworkBuildTemplate,
    kineticClubTemplate,
    launchpadBoldTemplate,
    meridianAdvisoryTemplate,
    nocturneClubTemplate,
    northlineStayTemplate,
    restaurantBrunchTemplate,
    restaurantCafeBrunchTemplate,
    restaurantModernTemplate,
    restaurantNightBarTemplate,
    restaurantPizzeriaTemplate,
    takeresTemplate,
    torqueServiceTemplate,
    voltFlowTemplate,
];

export const webTemplates: SiteTemplateDefinition[] = allWebTemplates.filter(
    (template) => template.manifest.visibility !== "private",
);

export const defaultWebTemplate = studioCleanTemplate;

export function findWebTemplate(code?: string | null): SiteTemplateDefinition | undefined {
    return allWebTemplates.find((template) => template.manifest.code === code);
}

export function getWebTemplate(code?: string | null): SiteTemplateDefinition {
    return findWebTemplate(code) ?? defaultWebTemplate;
}
